<template>
  <div>
    <ld-header @click-left="$emit('click-left')">
      <span @click="$emit('face-detection')">12306登录</span>
    </ld-header>

    <div class="train-login-wrap">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-notice-bar
          v-if="trSearchInfo.TravelVerificateType === travelVerificateType[12306]"
          wrapable
          :scrollable="false"
          text='"温馨提示"  铁路部规定：网络购票必须使用12306账号订票，请登录12306账号进行购票。'
          left-icon="info"
        />

        <div class="login-12306-wrap">
          <van-cell
            class="tips-card round-md overflow"
            title="铁路局规定购票需实名制"
            icon="location-o"
            label="登录12306账号，享极速退改、会员积分"
          >
            <template #icon>
              <ld-icon
                icon-class="main-color"
                size="28"
                type="iconiconfont12306"
                style="margin: 8px;margin-left: 0;"
              />
            </template>
          </van-cell>

          <van-cell-group class="mt10 round-md overflow">
            <van-field
              v-model="trainAccountModel"
              left-icon="contact"
              placeholder="请输入12306账号"
            />

            <van-field
              v-model="passwordModel"
              type="password"
              placeholder="请输入12306密码"
            >
              <ld-icon
                slot="left-icon"
                type="iconpassword"
              />
            </van-field>
            <van-cell>
              <van-checkbox
                class="font12"
                v-model="readModel"
                icon-size="16"
              >
                同意
                <span
                  class="main-color"
                  @click="$emit('show-agreement')"
                >《{{ agreement.title }}》</span>
              </van-checkbox>
            </van-cell>
            <div style="padding: 12px;">
              <ld-button
                @click="$emit('login')"
                size="lg"
                main
              >
                登录12306
              </ld-button>
            </div>
          </van-cell-group>


          <div class="mt10">
            <van-radio-group
              class="van-hairline--surround round-sm round-md overflow"
              v-model="trainAccountModel"
            >
              <van-cell-group>
                <van-cell>
                  <span class="gray">历史登录账号:</span>
                </van-cell>
                <van-cell
                  v-for="account in accountList"
                  :key="account.id"
                  @click="checkAccount(account)"
                >
                  <template #title>
                    <van-radio :name="account.currentTrainAccount">
                      {{ account.currentTrainAccount }}
                      <span v-show="trSearchInfo['12306Info'].trainAccount === account.currentTrainAccount">(已登录)</span>
                    </van-radio>
                  </template>

                  <van-icon
                    name="close"
                    @click.stop="$emit('account-del', account.id)"
                  />
                </van-cell>

                <van-cell
                  v-if="accountList.length === 0"
                  title=""
                  label="暂无12306账号"
                />

                <van-cell>
                  <span class="gray">当前出行人使用过的账号:</span>
                </van-cell>
                <van-cell
                  v-for="account in cxrAccountList"
                  :key="account.id"
                  @click="checkAccount(account)"
                >
                  <template #title>
                    <van-radio :name="account.currentTrainAccount">
                      {{ account.currentTrainAccount }}  {{ account.cxrName }}
                      <span v-show="trSearchInfo['12306Info'].trainAccount === account.currentTrainAccount">(已登录)</span>
                    </van-radio>
                  </template>
                </van-cell>

                <van-cell
                  v-if="cxrAccountList.length === 0"
                  title=""
                  label="暂无12306账号"
                />
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>

        <van-cell
          class="register-card round-md overflow"
          title="没有12306账号"
          icon="location-o"
          label="仅需提供证件+手机号"
        >
          <template #icon>
            <ld-icon
              icon-class="main-color"
              size="28"
              type="iconyiwancheng"
              style="margin: 8px;margin-left: 0;"
            />
          </template>
          <template #right-icon>
            <ld-button
              class="cell-btn"
              main3
              @click="$emit('show-register')"
            >
              快速注册
            </ld-button>
          </template>
        </van-cell>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { CellGroup, Cell, Field, RadioGroup, Radio, Checkbox, NoticeBar, Icon } from 'vant'
import ldButton from 'Common/ldButton'

export default {
  name: 'Train12306Content',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [NoticeBar.name]: NoticeBar,
    [Icon.name]: Icon,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton
  },
  props: {
    trainAccount: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
    read: {
      type: Boolean,
      default: true
    },
    down: {
      type: Object,
      default: () => ({ use: false })
    },
    accountList: {
      type: Array,
      default: () => []
    },
    cxrAccountList: {
      type: Array,
      default: () => []
    },
    trSearchInfo: {
      type: Object,
      default: () => ({})
    },
    agreement: {
      type: Object,
      default: () => ({ title: '账户授权协议' })
    },
    travelVerificateType: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    trainAccountModel: {
      get() {
        return this.trainAccount
      },
      set(value) {
        this.$emit('update:trainAccount', value)
      }
    },
    passwordModel: {
      get() {
        return this.password
      },
      set(value) {
        this.$emit('update:password', value)
      }
    },
    readModel: {
      get() {
        return this.read
      },
      set(value) {
        this.$emit('update:read', value)
      }
    }
  },
  methods: {
    checkAccount(account) {
      this.$emit('check-account', account)
    }
  }
}
</script>

<style lang="less" scoped>
.train-login-wrap {
  height: calc(100vh - 123px);
  overflow: hidden;
}

.login-12306-wrap {
  padding: 10px 8px;

  .mt10 {
    margin-top: 10px;
  }

  .tips-card {
    background-color: @color-background-lightYellow;
    border: 1px solid @color-text-main;
  }

  .van-cell__title {
    flex: auto;
  }
}

.register-card {
  width: calc(100% - 16px);
  margin: 0 8px;
  position: fixed;
  bottom: 8px;

  .cell-btn {
    width: auto;
    height: 32px;
    margin: 8px;
    margin-right: 0;
  }
}
</style>
